import { useEffect, useState } from "react";

import { StorageKeys } from "./storageKeys";
import type { GridColumnVisibilityModel } from "@mui/x-data-grid";

import { ReadFromLocalStorage, WriteToLocalStorage } from "@/service/Utilities";

const KEY = StorageKeys.shiftColumnVisibility;

/**
 * Persisted column visibility for Shift log/search/handover/out-of-service DataGrids.
 * Syncs across tabs via storage events.
 */
export function useShiftColumnVisibility(): [
	GridColumnVisibilityModel,
	React.Dispatch<React.SetStateAction<GridColumnVisibilityModel>>,
] {
	const [columnVisibilityModel, setColumnVisibilityModel] =
		useState<GridColumnVisibilityModel>(() =>
			ReadFromLocalStorage<GridColumnVisibilityModel>(KEY, {}),
		);

	useEffect(() => {
		WriteToLocalStorage(KEY, columnVisibilityModel);
	}, [columnVisibilityModel]);

	useEffect(() => {
		if (typeof window === "undefined") return;
		const onStorage = (e: StorageEvent) => {
			if (e.key === KEY && e.newValue) {
				try {
					const next = JSON.parse(e.newValue) as GridColumnVisibilityModel;
					setColumnVisibilityModel(next);
				} catch {
					// ignore
				}
			}
		};
		window.addEventListener("storage", onStorage);
		return () => window.removeEventListener("storage", onStorage);
	}, []);

	return [columnVisibilityModel, setColumnVisibilityModel];
}
